import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button } from "antd";
import PumpReportsHistory from "../components/PumpReportsHistory";
import { jsx as _jsx } from "react/jsx-runtime";
var PumpReport = function PumpReport() {
  return /*#__PURE__*/_jsx(Row, {
    children: /*#__PURE__*/_jsx(Col, {
      lg: 12,
      md: 12,
      children: /*#__PURE__*/_jsx(PumpReportsHistory, {})
    })
  });
};
export default PumpReport;